import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';
import './styles/tokens.css';
import './styles/base.css';
import './styles/bootstrap-overrides.css';
import './styles/responsive.css';
import './components/ui/incremental-list.css';
import './styles/marketing.css';

import { loadRuntimeConfig, setRuntimeConfig } from './app/config/runtime-config';
import { configureCognito } from './auth/auth-client';
import { AppProviders } from './app/providers/AppProviders';
import { router } from './app/router';
import { applyTheme, getThemePreference } from './utils/theme';

async function bootstrapRoute42() {
  applyTheme(getThemePreference());
  const config = await loadRuntimeConfig();
  setRuntimeConfig(config);
  configureCognito(config);

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </React.StrictMode>,
  );
}

bootstrapRoute42().catch((error: unknown) => {
  const message = error instanceof Error ? error.message : 'Route42 could not initialize.';
  const root = document.getElementById('root');
  if (!root) return;

  const main = document.createElement('main');
  main.style.cssText = 'font-family:system-ui,sans-serif;max-width:720px;margin:12vh auto;padding:24px';
  const title = document.createElement('strong');
  title.textContent = 'Route42 could not start.';
  const detail = document.createElement('p');
  detail.textContent = message;
  main.append(title, detail);
  root.replaceChildren(main);
});
